import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import config from 'config'

import styles from './success-badges.styl'
import appleStoreBadge from 'assets/img/badges/apple-store-badge.png'
import googlePlayBadge from 'assets/img/badges/google-play-badge.png'
import orbOnlineBadge from 'assets/img/badges/orb-online-badge.png'

export default class SuccessBadges extends Component {
  static propTypes = {
    isAwardStaff: PropTypes.bool
  }

  render() {
    const { isAwardStaff } = this.props
    
    const appStoreLink = isAwardStaff
      ? config.iosLeaderAppLink
      : config.iosAppLink

    const androidStoreLink = isAwardStaff
      ? config.androidLeaderAppLink
      : config.androidAppLink

    return (
      <div className={styles.wrap}>
        <div className={styles.smartphones}>
          <h4 className={styles.header}>
            <FormattedMessage
              id="label.on_your_smartphone"
              defaultMessage="On your smartphone"
            />
          </h4>

          <div>
            <a className={styles.badge} target="_blank" href={appStoreLink}>
              <img
                src={appleStoreBadge}
                className={styles.badge}
                alt="App store badge"
              />
            </a>
            <a className={styles.badge} target="_blank" href={androidStoreLink}>
              <img
                src={googlePlayBadge}
                className={styles.badge}
                alt="Google play badge"
              />
            </a>
          </div>
        </div>

        <div className={styles.web}>
          <h4 className={styles.header}>
            <FormattedMessage
              id="label.on_the_web"
              defaultMessage="On the wev"
            />
          </h4>

          <div className={styles.linkWrap}>
            <Link to={`${config.publicPath}/`} className={styles.link}>
              <img
                src={orbOnlineBadge}
                className={styles.orbBadge}
                alt="ORB online"
              />
            </Link>
          </div>
        </div>
      </div>
    )
  }
}
